<span
  #availabilityTooltipContainer
  class="d-inline-flex product-availability-icon-container align-items-center"
  data-bs-toggle="tooltip"
  data-bs-html="true"
  [attr.data-bs-title]="availabilityTooltipHtmlContent"
  data-bs-sanitize="true"
  data-bs-delay="200"
  data-bs-placement="auto"
>
  @if (isLoading == true) {
    <app-loading-indicator-base [loadingIndicatorStyle]="eLoadingIndicatorStyle.EMBEDDED"></app-loading-indicator-base>
  }

  @if (isLoading != true) {
    @switch (productAvailabilityState) {
      @case (knownAvailabilityStates.Green) {
        <i class="bi bi-circle-fill bi-circle-fill-green"></i>
        <i class="bi bi-circle-fill bi-circle-fill-green"></i>
        <i class="bi bi-circle-fill bi-circle-fill-green"></i>
      }
      @case (knownAvailabilityStates.Yellow) {
        <i class="bi bi-circle-fill bi-circle-fill-yellow"></i>
        <i class="bi bi-circle-fill bi-circle-fill-yellow"></i>
        <i class="bi bi-circle-fill bi-circle-fill-grey"></i>
      }
      @case (knownAvailabilityStates.Red) {
        <i class="bi bi-circle-fill bi-circle-fill-red"></i>
        <i class="bi bi-circle-fill bi-circle-fill-grey"></i>
        <i class="bi bi-circle-fill bi-circle-fill-grey"></i>
      }
      @case (knownAvailabilityStates.Car) {
        <i class="bi bi-truck"></i>
      }
      @default {
        <i class="bi bi-circle-fill bi-circle-fill-grey"></i>
        <i class="bi bi-circle-fill bi-circle-fill-grey"></i>
        <i class="bi bi-circle-fill bi-circle-fill-grey"></i>
      }
    }
  }
</span>
